"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_1 = require("react-router");
var routers_1 = require("./routers");
exports.default = (function (pathname) {
    var routers = routers_1.getRouters();
    var res;
    routers.some(function (router) {
        if (react_router_1.matchPath(pathname, { path: router.path })) {
            res = router.loadingComponent;
            return true;
        }
        return false;
    });
    return res;
});
//# sourceMappingURL=findLoadingComponent.js.map